import { Environment } from '../../../config';
import request from '../../../utils/request';
import axios from 'axios';
import * as Types from '../types';

/** authenticateUser Endpoint */
interface IAuthenticateInput {
  username: string;
  password: string;
}

interface IAuthenticateOutput_User {
  uuid: string;
  role: string;
}

interface IAuthenticateOutput {
  access_token: string;
  user: IAuthenticateOutput_User;
}

export const authenticateUser = async (
  data: IAuthenticateInput
): Promise<IAuthenticateOutput> => {
  const result: any = await request(
    'post',
    `${Environment.API_BASE_URL}/api/oauth/login`,
    {
      username: data.username,
      password: data.password,
    }
  );
  return result.data.data;
};

/** registerUser Endpoint */

export const registerUser = async () => {};

/** Refresh token */
interface IRefreshTokenInput {
  token: string;
}

interface IRefreshTokenOutput {
  email: string;
  password: string;
}

export const refreshToken = async (
  token: IRefreshTokenInput
): Promise<IRefreshTokenOutput> => {
  const result: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/users/auth/access-token?token=${token}`
  );
  return result.data;
};

interface IForgotPassword {
  username: string;
}

export const forgotPassword = async (data: IForgotPassword): Promise<any> => {
  const result: any = await request(
    'post',
    `${Environment.API_BASE_URL}/api/oauth/forgot-password`,
    {
      username: data.username,
    }
  );
  return result.data;
};

interface IResetPasswordOutput {
  password: string;
  confirm_password: string;
  token: string;
}
export const resetPassword = async (
  input: IResetPasswordOutput
): Promise<Types.ResponseOutput> => {
  // console.log(input.token);
  // const instance = axios.create();
  const { data } = await axios({
    method: 'patch',
    url: `${Environment.API_BASE_URL}/api/oauth/change-password`,
    data: {
      password: input.password,
      confirm_password: input.confirm_password,
    },
    headers: {
      'x-access-token': input.token,
    },
  });

  let output: Types.ResponseOutput = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};

/** TEST */

// interface IRefreshTokenInput {
//     token: string;
// }

interface ITestOutput {
  email: string;
  password: string;
}

export const test = async (): Promise<ITestOutput> => {
  const result: any = await request(
    'post',
    `${Environment.API_BASE_URL}/api/users/test`
  );
  return result.data;
};

export const fetchVersion = async (): Promise<string> => {
  const result: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/version`
  );
  return result.data.data.version;
};
